// 09-10 (Pau aprobó la maqueta: «el muñeco y la lista dicen lo mismo»). Lo que hace el muñeco en su mesa sale de
// la MISMA situación S12 que la lista (marco/situacion.ts), no del estado visual S11: antes la etiqueta decía
// «Te ha escrito» y el muñeco seguía tecleando con el monitor encendido.
import type { Animacion } from '../../../lib/oficina/pixel-art';
import type { ContratadoDTO } from '../compartido/vocabulario';

export interface Pose {
  animacion: Animacion;
  /** Monitor encendido: solo mientras trabaja de verdad (trabajando, o la oficina cerrando su trabajo). */
  monitor: boolean;
}

export function poseDe(c: Pick<ContratadoDTO, 'situacion' | 'visual'>): Pose {
  switch (c.situacion) {
    case 'trabajando':
    case 'cerrando':
      return { animacion: 'teclea', monitor: true };
    // Pide permiso o no puede seguir: levanta la vista, pensando (espera a Pau).
    case 'autorizacion':
    case 'bloqueado':
      return { animacion: 'piensa', monitor: false };
    // Solo duerme si su proceso ha fallado de verdad; el resto de problemas (sin cupo, mensajes sin entregar,
    // dormido que el despertador levanta) los arregla la oficina: espera tranquilo.
    case 'problema':
      return { animacion: c.visual === 'error' ? 'duerme' : 'lee', monitor: false };
    // Te ha escrito, sin nada pendiente, llegando o saliendo: en reposo, leyendo.
    default:
      return { animacion: 'lee', monitor: false };
  }
}
